import moment from 'moment';
import swal from 'sweetalert';

export const configRequestDefault = (queryParams = {}) => {
    return {
        params: {
            source: 'general',
            ...queryParams,
        },
    };
};

export const configRequestDetails = (grouper, queryParams = {}) => {
    return {
        params: {
            source: 'group',
            group: grouper,
            ...queryParams,
        },
    };
};

export const hashGenerate = () => {
    return `m=${Math.random().toString(36).substr(2, 16)}`;
};

export const sanitizer = (value) => {
    return value.replace(new RegExp('[0-9-.]', 'g'), '');
};

export const generateDataset = (data, colors, extraPropsDataset) => {
    return data.map((item, index) => {
        const color = colors ? colors[index] : 'transparent';

        return {
            ...item,
            ...extraPropsDataset,
            backgroundColor: color,
            borderColor: color,
            borderWidth: 1,
            hoverBorderColor: color,
            lineTension: 0,
        };
    });
};

export const generateDataDashboardOverall = (data) => {
    const overall = { actual: [], planned: [], labels: [] };

    if (data) {
        data.forEach((item) => {
            const { result_actual, result_planed, name } = item;
            overall.actual.push(result_actual);
            overall.planned.push(result_planed);

            function deleteArray(arrayI, position) {
                return arrayI.splice(position, 1);
            }

            function arrayFormat(arrayPrincipal) {
                const nuevoArray = [];

                for (let i = arrayPrincipal.length; i > 0; i--) {
                    if (i > 0) {
                        if (arrayPrincipal[i - 1].length <= 10) {
                            if (arrayPrincipal.length > 1) {
                                nuevoArray.push(
                                    `${arrayPrincipal[i - 2]} ${arrayPrincipal[i - 1]}`
                                );
                                deleteArray(
                                    arrayPrincipal,
                                    arrayPrincipal.indexOf(arrayPrincipal[i - 1])
                                );
                                deleteArray(
                                    arrayPrincipal,
                                    arrayPrincipal.indexOf(arrayPrincipal[i - 2])
                                );
                            } else if (arrayPrincipal.length === 1) {
                                nuevoArray.push(arrayPrincipal[i - 1]);
                                deleteArray(
                                    arrayPrincipal,
                                    arrayPrincipal.indexOf(arrayPrincipal[i - 1])
                                );
                            }

                            i = arrayPrincipal.length + 1;

                            if (arrayPrincipal.length === 0) {
                                break;
                            }
                        } else if (arrayPrincipal[i - 1].length > 10) {
                            nuevoArray.push(arrayPrincipal[i - 1]);
                            deleteArray(
                                arrayPrincipal,
                                arrayPrincipal.indexOf(arrayPrincipal[i - 1])
                            );
                        }
                    }
                }

                return nuevoArray;
            }

            if (name) {
                const arrayInicial = name.split(' ');
                overall.labels.push(arrayFormat(arrayInicial, 1).reverse());
            }
        });
    }

    return overall;
};

export const generateDateRangesProcessWeek = (configuration) => {
    const {
        all,
        this_month: thisMonth,
        last_month: lastMonth,
        this_quarter: thisQuarter,
        last_quarter: lastQuarter,
        this_year: thisYear,
        last_year: lastYear,
    } = configuration;

    return {
        All: [moment(all.start, 'MM-DD-YYYY'), moment(all.end, 'MM-DD-YYYY')],
        'This Month': [moment(thisMonth.start, 'MM-DD-YYYY'), moment(thisMonth.end, 'MM-DD-YYYY')],
        'Last Month': [moment(lastMonth.start, 'MM-DD-YYYY'), moment(lastMonth.end, 'MM-DD-YYYY')],
        'This Quarter': [
            moment(thisQuarter.start, 'MM-DD-YYYY'),
            moment(thisQuarter.end, 'MM-DD-YYYY'),
        ],
        'Last Quarter': [
            moment(lastQuarter.start, 'MM-DD-YYYY'),
            moment(lastQuarter.end, 'MM-DD-YYYY'),
        ],
        'This Year': [moment(thisYear.start, 'MM-DD-YYYY'), moment(thisYear.end, 'MM-DD-YYYY')],
        'Last Year': [moment(lastYear.start, 'MM-DD-YYYY'), moment(lastYear.end, 'MM-DD-YYYY')],
    };
};

export const changeHeightLegend = (chart, value = 50) => {
    chart.Legend.prototype.afterFit = function () {
        this.height += value;
    };
};

export const defaultGraphicOptions = () => {
    return {
        responsive: true,
        layout: {
            padding: {
                left: 10,
                right: 10,
            },
        },
        legend: {
            display: true,
            labels: {
                usePointStyle: true,
                fontSize: 10,
                padding: 40,
            },
        },
        tooltips: {
            cornerRadius: 0,
            yAlign: 'bottom',
            xAlign: 'center',
        },
        scales: {
            xAxes: [
                {
                    barPercentage: 1.0,
                    gridLines: {
                        display: false,
                        drawBorder: false,
                    },
                },
            ],
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                    gridLines: {
                        display: false,
                        drawBorder: false,
                    },
                },
            ],
        },
        maintainAspectRatio: false,
    };
};

export const sliderConfiguration = (extraOptions) => {
    return {
        className: 'center',
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 5,
        initialSlide: 0,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    className: 'center',
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
        ...extraOptions,
    };
};

export const flattenSiteChildren = ({ children, ...rest }) => {
    if (Object.prototype.hasOwnProperty.call(rest, 'is_rendered') && !rest.is_rendered) {
        return children;
    } else {
        return children ? [rest].concat(children.flatMap(flattenSiteChildren)) : [rest];
    }
};

export const transformSiteRow = (item) => {
    const { columns, ...extraOptions } = item;

    return columns
        .map((child) => ({ ...child, extraOptions }))
        .reduce((instance, row) => {
            const { content, extraOptions, forescat_alert, highlight_color, slug } = row;
            instance[slug] = content;
            instance['extraOptions'] = instance.extraOptions || extraOptions;
            instance.extraOptions['forescats'] = instance.extraOptions['forescats'] || [];
            instance.extraOptions['highlight_colors'] =
                instance.extraOptions['highlight_colors'] || {};

            if (forescat_alert) {
                instance.extraOptions['forescats'].push({ slug, value: content });
            }

            if (highlight_color) {
                instance.extraOptions['highlight_colors'][slug] = highlight_color;
            }

            return instance;
        }, {});
};

export const generateRowsProjectSite = (
    subproject,
    callbackState,
    callbackRequest,
    extraParams,
    callbackSubtotals
) => {
    subproject &&
        Promise.resolve(callbackRequest(subproject, extraParams)).then((response) => {
            const data = response?.data ?? response ?? {};

            if (!data) {
                swal('Opsssss!', `There are no results for the search`, 'warning');
            }

            if (callbackSubtotals) {
                callbackSubtotals(data.subtotals ?? null);
            }

            callbackState(() => {
                try {
                    return (data.sites ?? []).flatMap(flattenSiteChildren).map(transformSiteRow);
                } catch (error) {
                    callbackState([]);
                }
            });
        });
};

export const downloaderFiles = (file, filename) => {
    const url = window.URL.createObjectURL(new Blob([file]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
};

/**
 * Checks whether a user has a specific permission codename.
 * Looks in both user.user_permissions and user.groups[].permissions.
 * Superusers always return true.
 *
 * @param {object|null} user - The auth user object from Redux / localStorage.
 * @param {string} permCode - The Django permission codename to check.
 * @returns {boolean}
 */
export const userHasPerm = (user, permCode) => {
    if (!user) {
        return false;
    }

    if (user.is_superuser) {
        return true;
    }

    // Direct user permissions
    if (Array.isArray(user.user_permissions)) {
        if (user.user_permissions.find((p) => p.codename === permCode)) {
            return true;
        }
    }

    // Group permissions
    if (Array.isArray(user.groups)) {
        for (const group of user.groups) {
            if (Array.isArray(group.permissions)) {
                if (group.permissions.find((p) => p.codename === permCode)) {
                    return true;
                }
            }
        }
    }

    return false;
};

/**
 * Checks whether a user has ALL of the required permission codenames.
 * Returns true when requiredPerms is empty or undefined.
 *
 * @param {object|null} user - The auth user object.
 * @param {string[]} [requiredPerms] - Array of Django permission codenames.
 * @returns {boolean}
 */
export const userHasPermissions = (user, requiredPerms) => {
    if (!requiredPerms || requiredPerms.length === 0) {
        return true;
    }

    return requiredPerms.every((perm) => userHasPerm(user, perm));
};

/**
 * Safely reads and parses the authenticated user from localStorage.
 * Returns null if the key is missing or the JSON is invalid.
 *
 * @returns {object|null}
 */
export const getStoredUser = () => {
    try {
        return JSON.parse(localStorage.getItem('user'));
    } catch {
        return null;
    }
};

/**
 * Standard Axios .catch() handler that rejects with response.data.
 * Usage: .catch(rejectApiError)
 *
 * @param {{ response: object }} axiosError
 * @returns {Promise<never>}
 */
export const rejectApiError = ({ response }) => Promise.reject(response?.data);

/**
 * Standard Axios .catch() handler that rejects with response.data.errors.
 * Usage: .catch(rejectApiErrors)
 *
 * @param {{ response: object }} axiosError
 * @returns {Promise<never>}
 */
export const rejectApiErrors = ({ response }) => Promise.reject(response?.data?.errors);
